var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("error.general"),
        "header-bg-variant": "danger",
        "header-text-variant": "white",
        size: "lg",
        scrollable: "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ hide }) {
            return [
              _c(
                "b-button",
                { attrs: { variant: "outline-danger" }, on: { click: hide } },
                [_vm._v("\n      " + _vm._s(_vm.$t("btn.close")) + "\n    ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm.errorSummary
        ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
            _vm._v("\n    " + _vm._s(_vm.errorSummary) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.errorDiagnostics, function (error, index) {
        return _c(
          "section",
          { key: index, staticClass: "modal-connector-error-section" },
          [
            _c(
              "div",
              { staticClass: "modal-connector-error-section-header" },
              [
                _c("strong", [_vm._v(_vm._s(error.title))]),
                _vm._v(" "),
                _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("\n        " + _vm._s(error.status) + "\n      "),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            error.message
              ? _c("div", { staticClass: "modal-connector-error-message" }, [
                  _vm._v("\n      " + _vm._s(error.message) + "\n    "),
                ])
              : _c("div", { staticClass: "modal-connector-error-no-message" }, [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("error.unknown")) + "\n    "
                  ),
                ]),
            _vm._v(" "),
            _c(
              "dl",
              { staticClass: "modal-connector-error-meta" },
              [
                error.method || error.url
                  ? [
                      _c(
                        "dt",
                        { staticClass: "modal-connector-error-meta-title" },
                        [_vm._v(_vm._s(_vm.$t("label.request")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "dd",
                        { staticClass: "modal-connector-error-meta-content" },
                        [
                          error.method
                            ? _c("span", [_vm._v(_vm._s(error.method))])
                            : _vm._e(),
                          _vm._v(" "),
                          error.url
                            ? _c(
                                "code",
                                { staticClass: "modal-connector-error-url" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(error.url) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                error.details
                  ? [
                      _c(
                        "dt",
                        { staticClass: "modal-connector-error-meta-title" },
                        [_vm._v(_vm._s(_vm.$t("label.technical_details")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "dd",
                        { staticClass: "modal-connector-error-meta-content" },
                        [
                          _c(
                            "pre",
                            { staticClass: "modal-connector-error-details" },
                            [_vm._v(_vm._s(error.details))]
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }